/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/js/anniversary/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	window.getAbsoluteUrl = (function() {
	    var a;
	
	    return function(url) {
	        if(!a) a = document.createElement('a');
	        a.href = url;
	
	        return a.href;
	    };
	})();
	
	__webpack_require__(1);
	
	$('.js-video').on('play', function () {
	    $(this).fadeIn(1000);
	    $(this).off('play');
	});


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	window.getAbsoluteUrl = (function() {
	    var a;
	
	    return function(url) {
	        if(!a) a = document.createElement('a');
	        a.href = url;
	
	        return a.href;
	    };
	})();
	
	var obj = {
	    title: "《天谕》生日快乐！",
	    desc: "欢迎您来到《天谕》周年庆典的现场，游园赢取限量道具周边，同贺天谕周年生日！",
	    pic: getAbsoluteUrl(__webpack_require__(2)),
	    url: window.location.href
	};
	
	var weiboobj = {
	    title: obj.title,
	    desc: encodeURIComponent(obj.desc),
	    pic: encodeURIComponent(obj.pic),
	    url: encodeURIComponent(obj.url)
	};
	
	
	$('.share-btn').click(function (event) {
	    var id = $(this).data("id");
	    switch (id) {
	        case "yx":
	            snsShare.init(obj);
	            snsShare.toYixin();
	            break;
	        case "xl":
	            snsShare.init(weiboobj);
	            snsShare.toSinaWeibo();
	            break;
	        case "wx":
	            snsShare.init(obj);
	            var url="http://res.nie.netease.com/comm/js/nie/util/share/api/index.html?url="+window.location.href;
	            window.open(url,'','width='+640+',height='+480);
	            break;
	    }
	});
	
	$(".f-share-icon").hover(
	    function(){
	        $(".f-share-icon").addClass("active");
	    },
	    function(){
	        $(".f-share-icon").removeClass("active");
	    }
	);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c349a51068148206d7ce7be9ea688d4b.jpg";

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.js